/**
 * component to render in Selections tab at How to Nominate page E50
 */
const DeclarationsPage = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-250 p-4 font-public-sans"
      data-testid="selections-page-component"
    >
      <p>
        By submitting your nomination, you declare that the facts stated in this
        application together with the accompanying information are true and
        correct, and have satisfied the eligibility criteria.
      </p>

      <p>By submitting your nomination, you agree:</p>

      <ul className="mb-4 list-outside list-disc pl-8">
        <li>
          that all figures provided in the nomination form, except for the gross
          operating profit figures, may be published and used for research
          purposes;
        </li>
        <li>
          to provide relevant company information should the organisers need to
          verify the data provided in the nomination form (upon request);
        </li>
        <li>
          to provide the company&apos;s projected financial figures for 2025
          (upon request);
        </li>
        <li>
          to notify the organisers in the event your company, holding company or
          subsidiaries have successfully applied for public listing and expect
          such a listing on or before 30 June 2024;
        </li>
        <li>
          to notify the organisers in the event of any changes to your
          company&apos;s eligibility for the awards;
        </li>
        <li>
          to provide details of any litigation cases against your company and/or
          your company&apos;s directors/shareholders in the run-up to the
          publication of the 2025 E50 Awards list;
        </li>
        <li>
          to abide by the publicity schedules and guidelines stipulated by the
          organisers in the run-up to and after the publication of the 2025 E50
          Awards list;
        </li>
        <li>
          to provide relevant information about your company for purposes of
          inclusion in E50-related collaterals, i.e. books, write-ups, etc.;
        </li>
        <li>
          to abide by the rules and standards regarding the usage of the E50
          logo;
        </li>
        <li>to abide by the decisions of the judges; and</li>
        <li>
          that any award may be revoked by the organisers in the event that any
          of the above conditions are breached.
        </li>
      </ul>
    </div>
  );
};

export default DeclarationsPage;
